// Read-only data hook for the worker's heartbeat doc. The doc lives at
// worker_metrics/heartbeat (top-level, not team-scoped — the worker is a
// shared resource). Firestore rules expose this to team members.

import { doc } from 'firebase/firestore'
import { useDocument } from 'react-firebase-hooks/firestore'
import { db } from './firebase.js'

/**
 * @param {import('firebase/firestore').DocumentSnapshot | undefined} snapshot
 */
function unwrap(snapshot) {
  if (!snapshot?.exists()) return null
  return { id: snapshot.id, ...snapshot.data() }
}

export function useWorkerHeartbeat() {
  const ref = doc(db, 'worker_metrics', 'heartbeat')
  const [snap, loading, error] = useDocument(ref)
  return { data: unwrap(snap), loading, error }
}

const STALE_THRESHOLD_MS = 5 * 60 * 1000

/**
 * @param {{ lastBeat?: any } | null | undefined} heartbeat
 *   `lastBeat` is a Firestore field that may be an ISO string or a Timestamp
 *   (with a `.toMillis()` method), hence the permissive field type.
 */
export function isHeartbeatStale(heartbeat) {
  if (!heartbeat?.lastBeat) return true
  const lastMs =
    typeof heartbeat.lastBeat === 'string'
      ? new Date(heartbeat.lastBeat).getTime()
      : (heartbeat.lastBeat.toMillis?.() ?? Number(heartbeat.lastBeat))
  if (!lastMs) return true
  return Date.now() - lastMs > STALE_THRESHOLD_MS
}

export { STALE_THRESHOLD_MS }
